/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as SkincheckResultImport } from './routes/skincheck-result';
import { Route as SkincheckImport } from './routes/skincheck';
import { Route as LoginImport } from './routes/login';
import { Route as DeviceImport } from './routes/device';
import { Route as ChatImport } from './routes/chat';
import { Route as CameraPermissionImport } from './routes/camera-permission';
import { Route as ArticlesImport } from './routes/articles';
import { Route as IndexImport } from './routes/index';

// Create/Update Routes

const SkincheckResultRoute = SkincheckResultImport.update({
  id: '/skincheck-result',
  path: '/skincheck-result',
  getParentRoute: () => rootRoute,
} as any);

const SkincheckRoute = SkincheckImport.update({
  id: '/skincheck',
  path: '/skincheck',
  getParentRoute: () => rootRoute,
} as any);

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any);

const DeviceRoute = DeviceImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRoute,
} as any);

const ChatRoute = ChatImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRoute,
} as any);

const CameraPermissionRoute = CameraPermissionImport.update({
  id: '/camera-permission',
  path: '/camera-permission',
  getParentRoute: () => rootRoute,
} as any);

const ArticlesRoute = ArticlesImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/articles': {
      id: '/articles';
      path: '/articles';
      fullPath: '/articles';
      preLoaderRoute: typeof ArticlesImport;
      parentRoute: typeof rootRoute;
    };
    '/camera-permission': {
      id: '/camera-permission';
      path: '/camera-permission';
      fullPath: '/camera-permission';
      preLoaderRoute: typeof CameraPermissionImport;
      parentRoute: typeof rootRoute;
    };
    '/chat': {
      id: '/chat';
      path: '/chat';
      fullPath: '/chat';
      preLoaderRoute: typeof ChatImport;
      parentRoute: typeof rootRoute;
    };
    '/device': {
      id: '/device';
      path: '/device';
      fullPath: '/device';
      preLoaderRoute: typeof DeviceImport;
      parentRoute: typeof rootRoute;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    '/skincheck': {
      id: '/skincheck';
      path: '/skincheck';
      fullPath: '/skincheck';
      preLoaderRoute: typeof SkincheckImport;
      parentRoute: typeof rootRoute;
    };
    '/skincheck-result': {
      id: '/skincheck-result';
      path: '/skincheck-result';
      fullPath: '/skincheck-result';
      preLoaderRoute: typeof SkincheckResultImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/articles': typeof ArticlesRoute;
  '/camera-permission': typeof CameraPermissionRoute;
  '/chat': typeof ChatRoute;
  '/device': typeof DeviceRoute;
  '/login': typeof LoginRoute;
  '/skincheck': typeof SkincheckRoute;
  '/skincheck-result': typeof SkincheckResultRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/articles': typeof ArticlesRoute;
  '/camera-permission': typeof CameraPermissionRoute;
  '/chat': typeof ChatRoute;
  '/device': typeof DeviceRoute;
  '/login': typeof LoginRoute;
  '/skincheck': typeof SkincheckRoute;
  '/skincheck-result': typeof SkincheckResultRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/articles': typeof ArticlesRoute;
  '/camera-permission': typeof CameraPermissionRoute;
  '/chat': typeof ChatRoute;
  '/device': typeof DeviceRoute;
  '/login': typeof LoginRoute;
  '/skincheck': typeof SkincheckRoute;
  '/skincheck-result': typeof SkincheckResultRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/articles'
    | '/camera-permission'
    | '/chat'
    | '/device'
    | '/login'
    | '/skincheck'
    | '/skincheck-result';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/articles'
    | '/camera-permission'
    | '/chat'
    | '/device'
    | '/login'
    | '/skincheck'
    | '/skincheck-result';
  id:
    | '__root__'
    | '/'
    | '/articles'
    | '/camera-permission'
    | '/chat'
    | '/device'
    | '/login'
    | '/skincheck'
    | '/skincheck-result';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ArticlesRoute: typeof ArticlesRoute;
  CameraPermissionRoute: typeof CameraPermissionRoute;
  ChatRoute: typeof ChatRoute;
  DeviceRoute: typeof DeviceRoute;
  LoginRoute: typeof LoginRoute;
  SkincheckRoute: typeof SkincheckRoute;
  SkincheckResultRoute: typeof SkincheckResultRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArticlesRoute: ArticlesRoute,
  CameraPermissionRoute: CameraPermissionRoute,
  ChatRoute: ChatRoute,
  DeviceRoute: DeviceRoute,
  LoginRoute: LoginRoute,
  SkincheckRoute: SkincheckRoute,
  SkincheckResultRoute: SkincheckResultRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/articles",
        "/camera-permission",
        "/chat",
        "/device",
        "/login",
        "/skincheck",
        "/skincheck-result"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/articles": {
      "filePath": "articles.tsx"
    },
    "/camera-permission": {
      "filePath": "camera-permission.tsx"
    },
    "/chat": {
      "filePath": "chat.tsx"
    },
    "/device": {
      "filePath": "device.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/skincheck": {
      "filePath": "skincheck.tsx"
    },
    "/skincheck-result": {
      "filePath": "skincheck-result.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
